import React, { Component } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { View } from "react-native";
import { Button } from "native-base";
import Icon from "react-native-vector-icons/Ionicons";

class PlayAnswerFiles extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return(
            <View style={[styles.container,{flexDirection: "row",justifyContent: "center", alignItems: "center",}]}>
                <Button transparent style={[styles.playBtn, styles.passed]} onPress={this._onPlayAudio}>
                    <Icon size={18} name="ios-play" style={{ marginLeft: 2 }} color="#fff" />
                </Button>
            </View>
        )
    }

    _onPlayAudio = () => {
        if (this.props.onPlayAudio && _.isFunction(this.props.onPlayAudio)) {
            this.props.onPlayAudio();
        }
    };
}

const styles = {
    container: {
        paddingHorizontal: 10,
        height: 70,
        paddingVertical: 15,
    },
    playBtn: {
        backgroundColor: "#777",
        height: 48,
        width: 48,
        borderRadius: 50,
        justifyContent: "center",
        margin: 20,
    },
    passed: {
        backgroundColor: "#66bb6a",
    },
};

PlayAnswerFiles.propTypes = {
    onPlayAudio: PropTypes.func,
};

PlayAnswerFiles.defaultProps = {

};

export default PlayAnswerFiles;
